export const googleKey = 'AIzaSyDVmek6lHUCruPzAXCsvLYVDAnVhZzLtwM';

export const activeDrawerBoundOptions = { paddingTopLeft: [400, 0], paddingBottomRight: [125, 0] };
export const closedDrawerBoundOptions = { paddingTopLeft: [0, 0] };
